import { init, setUser } from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import store from '@/store'

init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,

    environment: process.env.MIX_SENTRY_APP_ENV,

    integrations: [new Integrations.BrowserTracing()],

    release: process.env.MIX_SENTRY_RELEASE,

    tracesSampleRate: parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE),

    beforeSend(event, hint) {
        const code = hint.originalException?.code

        if (
            hint.originalException === "Timeout" ||
            code === 'error-fetch-api' ||
            code === 'error-upload-image'
        ) {
            return null
        }

        return event
    },

    denyUrls: [
        '//hidden/', // extenção do safari: https://github.com/getsentry/sentry-javascript/discussions/5875
    ],
})

const user = store();

if (user.isAuthenticate) {
    setUser({
        id: user.auth.id,
        username: user.auth.name,
        ip_address: 'auto'
    })
}
